var transitionSpeeds = {
  "default": '.25s',
  smooth: '.5s',
  slow: '1s'
};
var transitionOpacityValues = {
  "default": '.75',
  reverse: '.25'
};
var transitions = {
  "default": "".concat(transitionSpeeds["default"], " ease"),
  smooth: "".concat(transitionSpeeds.smooth, " ease"),
  slow: "".concat(transitionSpeeds.slow, " ease")
};

export { transitionOpacityValues, transitionSpeeds, transitions };
//# sourceMappingURL=transitions.js.map
